import { render, staticRenderFns } from "./CreateTenantStaffPopUp.vue?vue&type=template&id=592d1e08&scoped=true"
import script from "./CreateTenantStaffPopUp.vue?vue&type=script&lang=js"
export * from "./CreateTenantStaffPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateTenantStaffPopUp.vue?vue&type=style&index=0&id=592d1e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d1e08",
  null
  
)

export default component.exports